import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import { Route, BrowserRouter, NavLink, Switch } from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import "./Assigned.css";
import deliveryBike from "../../images/delivery-bike.png";
import bmmiLogo from "../../images/BMMI_Shops_Logo.svg";
import { Row, Col } from "reactstrap";
import PhoneIcon from "../../images/call_icon.png";
import api from "../../utility/api/api.js";
import backImage from "../../images/backArrow.png";
// import OrderInTransit from "./ViewTripList/OrderInTransit";
import OrderInTransit from "../Intransit/ViewTripList/OrderInTransit";

// import {holdReasonAction} from '../../../actions/index';
// import {connect} from 'react-redux';
// import {bindActionCreators} from 'redux';
class AcceptModal extends React.Component {
  constructor(props) {
    super(props);
    console.log("newbaby", this.props && this.props.acctda);
    this.state = { modal: true, modal1: false, acceptresult: "" };
    this.masterData = JSON.parse(localStorage.getItem("getMasterData"));
    this.toggle = this.toggle.bind(this);
    this.callAcceptApi = this.callAcceptApi.bind(this);
    this.callRiderViewApi = this.callRiderViewApi.bind(this);
    const history = createHistory();
    const unlisten = history.listen((location, action) => {
      if (this.state.modal) {
        this.setState({ modal: true });
      }
    });
  }
  // componentWillMount() {
  //     this.setState({
  //         modal: !this.state.modal,error:''
  //     });

  // }
  callAcceptApi(id, e) {
    api.riderAcceptedJob(id, this);

    this.setState({
      modal: false,
      modal1: false,
    });
  }
  callRiderViewApi(jid, e) {
    api.callRiderViewApi(jid, this);
    this.setState({
      modal1: !this.state.modal1,
      modal: !this.state.modal,
    });
  }
  callRiderCancelApi(jid, e) {
    // api.callRiderViewApi(jid, this);
    api.rejectRiderTrip(jid);
    this.setState({
      modal1: false,
      modal: false,
    });
  }
  toggle() {
    this.setState({
      modal1: !this.state.modal1,
    });
  }

  getAddressFrom = (order) => {
    const addressString = [
      "flat_villa_no",
      "building",
      "street",
      "city",
      "postcode",
    ]
      .map((key) => {
        const lables = {
          street: "Street",
          city: "City",
          flat_villa_no: "Flat",
          building: "Building",
          postcode: "Pincode",
        };
        return order[key] && lables[key] + ":" + order[key];
      })
      .filter((n) => n)
      .join(", ");

    return addressString;
  };

  render() {
    return (
      <div>
        {this.props && this.props.acctda ? (
          <Modal
            isOpen={this.state.modal}
            backdrop={"static"}
            keyboard={false}
            fade={false}
            className={this.props.className}
          >
            <ModalBody>
              <div className="acceptbodymain">
                <div>
                  <img
                    src={deliveryBike}
                    alt="not found"
                    height="100"
                    width="100"
                  />
                </div>
                <div className="acceptsecbodypart">
                  <div>
                    <img src={bmmiLogo} alt="not found" height="50" />
                  </div>
                  <div>New Rider Job</div>
                </div>
              </div>
            </ModalBody>

            <div className="acceptfooter">
              <div
                className="text-center"
                onClick={(e) =>
                  this.callRiderCancelApi(this.props.acctda.job_id, e)
                }
              >
                Reject
              </div>
              <div
                className="text-center"
                onClick={(e) =>
                  this.callRiderViewApi(this.props.acctda.job_id, e)
                }
              >
                View
              </div>
              <div
                className="text-center"
                onClick={(e) => this.callAcceptApi(this.props.acctda.job_id, e)}
              >
                Accept
              </div>
            </div>
          </Modal>
        ) : null}

        {this.props && this.props.acctda ? (
          <Modal
            isOpen={this.state.modal1}
            backdrop={"static"}
            keyboard={false}
            fade={false}
            className={this.props.className}
          >
            <ModalBody className="acceptModalBody">
              <div
                className="backArrowInPopup"
                onClick={() =>
                  this.setState({
                    modal1: false,
                    modal: true,
                  })
                }
              >
                <img src={backImage} height="20px" />
              </div>
              {this.state.acceptresult &&
                this.state.acceptresult[0] &&
                this.state.acceptresult[0].data.orders.map((order, k) => (
                  <OrderInTransit
                    key={k}
                    trip_id={this.props.acctda.job_id}
                    orderData={order}
                    index={k + 1}
                    isFromAcceptModal={true}
                  />
                ))}
            </ModalBody>

            <div className="acceptfooter">
              <div
                className="text-center"
                onClick={(e) => this.callAcceptApi(this.props.acctda.job_id, e)}
              >
                Accept
              </div>
            </div>
          </Modal>
        ) : null}
      </div>
    );
  }
}
// function mapStateToProps(state){
//     console.log("holdDetails",state);
//   return {
//     holdData:state.getholdreasons

//   };
//   }
//   function mapDispatchToProps(dispatch){
//       return bindActionCreators({holdReasonAction:holdReasonAction},dispatch);
//   }
//   export default connect(mapStateToProps,mapDispatchToProps)(HoldReasons);
export default AcceptModal;



// WEBPACK FOOTER //
// ./src/components/Assigned/AcceptModal.js